import React, { useEffect, useRef } from "react";
import moment from "moment";
import {
  FiEye,
  FiSearch,
  FiFilter,
  FiToggleLeft,
  FiToggleRight,
  FiCheckCircle,
  FiXCircle,
  FiUser,
  FiCalendar,
  FiClock,
  FiTag,
  FiImage,
  FiFileText,
  FiGrid,
  FiList,
  FiRefreshCw,
  FiMoreVertical,
  FiArrowUp,
  FiArrowDown,
  FiTrendingUp,
  FiTrendingDown,
  FiAlertCircle,
  FiHash,
  FiUsers,
  FiPlayCircle,
  FiVideo,
  FiBookOpen,
} from "react-icons/fi";
import {
  MdOutlineSearch,
  MdOutlineFilter,
  MdOutlineVisibility,
  MdOutlineCategory,
  MdOutlinePerson,
  MdOutlineCalendarToday,
  MdOutlineCheckCircle,
  MdOutlineCancel,
  MdOutlinePending,
  MdOutlineAccessTime,
  MdOutlineVideoLibrary,
  MdOutlinePlayCircle,
  MdOutlinePeople,
  MdOutlineImage,
  MdOutlineDescription,
} from "react-icons/md";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { CiSearch } from "react-icons/ci";
import ReactPaginate from "react-paginate";
import DatePicker from "../../../components/ui/FromDateToDate";
import SortableHeader from "../../../components/SortableHeader";
import ToggleButton from "../../../components/Atoms/ToggleButton/ToggleButton";

const SessionManagementTable = ({
  filter,
  setFilter,
  TbaleName,
  TbaleHeader,
  TbaleData,
  showMenu,
  viewAction,
  total,
  handlePageClick,
  setAdminToggleData,
  currentSortKey,
  currentSortOrder,
  onSort,
  toggleAction,
}) => {
  const ContentActionRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        ContentActionRef.current &&
        !ContentActionRef.current.contains(event.target)
      ) {
        showMenu(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showMenu]);

  const handleDateChange = (name, value) => {
    setFilter((p) => ({
      ...p,
      [name]: value,
    }));
  };

  const Duration = (sloats) => {
    const allSlots = sloats.flatMap((slot) => slot.slots);
    if (!allSlots.length) return "N/A";

    const totalMinutes = allSlots.reduce((sum, slot) => {
      return sum + moment(slot.endTime).diff(moment(slot.startTime), "minutes");
    }, 0);

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;
  };

  const CountData = (slots) => {
    let count = slots.reduce((acc, item) => {
      let slotCount = item.slots.filter((slot) => slot.bookBy !== null).length;
      return acc + slotCount;
    }, 0);
    return count;
  };

  // Status badge component
  const StatusBadge = ({ isDisabled }) => {
    if (!isDisabled) {
      return (
        <span className="inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-full">
          <FiCheckCircle className="w-3.5 h-3.5 text-emerald-500" />
          Active
        </span>
      );
    }
    return (
      <span className="inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium text-rose-700 bg-rose-50 border border-rose-200 rounded-full">
        <FiXCircle className="w-3.5 h-3.5 text-rose-500" />
        Inactive
      </span>
    );
  };

  return (
    <div className="w-full">
      <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100/80 overflow-hidden">
        {/* Header Section */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 p-4 md:p-5 border-b border-gray-100 bg-gradient-to-r from-gray-50/50 to-white">
          <div className="flex items-center gap-3">
            <div className="p-1.5 bg-gradient-to-br from-[#855DF6]/10 to-[#715EFE]/10 rounded-lg">
              <MdOutlineVideoLibrary className="w-4 h-4 text-[#715EFE]" />
            </div>
            <div>
              <h2 className="text-base font-semibold text-gray-800">
                {TbaleName}
              </h2>
              <p className="text-xs text-gray-400 hidden sm:block">
                {TbaleData?.length || 0} sessions
              </p>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto">
            {/* Search */}
            <div className="relative flex-1 sm:min-w-[180px]">
              <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
              <input
                type="text"
                placeholder="Search sessions..."
                className="w-full pl-9 pr-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#715EFE]/20 focus:border-[#715EFE] transition-all duration-200"
                onChange={(e) => handleDateChange("keyWord", e.target.value)}
                value={filter.keyWord}
              />
            </div>

            {/* Date Pickers */}
            <div className="flex items-center gap-2">
              <DatePicker
                date={filter.fromDate}
                label={
                  <div className="flex items-center gap-1.5">
                    <FiCalendar className="w-3.5 h-3.5 text-gray-400" />
                    <span className="text-xs">From</span>
                  </div>
                }
                onDateChange={(value) => handleDateChange("fromDate", value)}
                className="w-[130px]"
              />
              <span className="text-gray-400 text-xs">→</span>
              <DatePicker
                date={filter.toDate}
                label={
                  <div className="flex items-center gap-1.5">
                    <FiCalendar className="w-3.5 h-3.5 text-gray-400" />
                    <span className="text-xs">To</span>
                  </div>
                }
                onDateChange={(value) => handleDateChange("toDate", value)}
                className="w-[130px]"
              />
            </div>
          </div>
        </div>

        {/* Table Section */}
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-50/80 text-xs font-semibold text-gray-500 uppercase tracking-wider border-b border-gray-100">
                {TbaleHeader.map((heading, index) => {
                  const headerIcons = {
                    "#": null,
                    "Session Title": FiTag,
                    Duration: FiClock,
                    "Expert Name": FiUser,
                    Enrollment: FiUsers,
                    "Admin Status": FiToggleLeft,
                    "Created Date": FiCalendar,
                    Action: null,
                  };
                  const Icon = headerIcons[heading.label] || headerIcons[heading.label?.trim()];
                  return (
                    <th key={index} className="px-3 md:px-4 py-3 whitespace-nowrap">
                      <SortableHeader
                        label={heading.label}
                        sortKey={heading.sortKey}
                        currentSortKey={currentSortKey}
                        currentSortOrder={currentSortOrder}
                        onSort={onSort}
                        icon={Icon}
                      />
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {TbaleData && TbaleData.length > 0 ? (
                TbaleData.map((ele, index) => (
                  <tr
                    key={ele.id || index}
                    className="hover:bg-gray-50/70 transition-colors duration-150 group"
                  >
                    <td className="px-3 md:px-4 py-3">
                      <span className="text-sm font-medium text-gray-400">
                        {(filter.pageNo - 1) * filter.size + index + 1}
                      </span>
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <div className="flex items-center gap-3">
                        <div className="flex-shrink-0 w-12 h-12 rounded-lg overflow-hidden bg-gray-100 border border-gray-200">
                          <img
                            src={ele?.thumbUrl || "/Img/library.png"}
                            alt="thumbnail"
                            className="w-full h-full object-cover"
                            onError={(e) => (e.target.src = "/Img/library.png")}
                          />
                        </div>
                        <span className="text-sm font-medium text-gray-800 truncate max-w-[120px] md:max-w-[180px]">
                          {ele.title || "Untitled"}
                        </span>
                      </div>
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <div className="flex items-center gap-1.5">
                        <FiClock className="w-3.5 h-3.5 text-gray-400" />
                        <span className="text-sm font-medium text-gray-700">
                          {Duration(ele?.sloats)}
                        </span>
                      </div>
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <div className="flex items-center gap-2.5">
                        <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#855DF6]/10 to-[#715EFE]/10 flex items-center justify-center">
                          <span className="text-xs font-bold text-[#715EFE]">
                            {ele?.user?.fullName?.charAt(0)?.toUpperCase() ||
                              "U"}
                          </span>
                        </div>
                        <span className="text-sm text-gray-700 truncate max-w-[80px]">
                          {ele?.user?.fullName || "Unknown"}
                        </span>
                      </div>
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <div className="flex items-center gap-1.5">
                        <FiUsers className="w-3.5 h-3.5 text-[#715EFE]" />
                        <span className="text-sm font-semibold text-gray-700">
                          {CountData(ele?.sloats)}
                        </span>
                      </div>
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <StatusBadge isDisabled={ele?.isDisableByAdmin} />
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <div className="flex flex-col">
                        <span className="text-sm text-gray-700 whitespace-nowrap">
                          {ele.createdAt
                            ? moment(ele.createdAt).format("MMM D, YYYY")
                            : "N/A"}
                        </span>
                        {ele.createdAt && (
                          <span className="text-xs text-gray-400">
                            {moment(ele.createdAt).format("h:mm A")}
                          </span>
                        )}
                      </div>
                    </td>
                    <td className="px-3 md:px-4 py-3 flex justify-start items-center">
                    
                      <button
                        className="p-1.5 text-blue-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-200"
                        onClick={() => viewAction(ele)}
                        title="View Details"
                      >
                        <FiEye className="w-4 h-4" />
                      </button>

                      <ToggleButton
                        isDisabled={ele?.isDisableByAdmin}
                        onToggle={() => toggleAction(ele)}
                        activeColor="green"
                        size="sm"
                        activeText="Active"
                        inactiveText="Inactive"
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={TbaleHeader.length}
                    className="px-4 py-12 text-center"
                  >
                    <div className="flex flex-col items-center gap-3">
                      <div className="p-4 bg-gray-50 rounded-full">
                        <MdOutlineVideoLibrary className="w-10 h-10 text-gray-300" />
                      </div>
                      <p className="text-sm font-medium text-gray-500">
                        No sessions found
                      </p>
                      <p className="text-xs text-gray-400">
                        Try adjusting your search or filters
                      </p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {Math.ceil(total / filter.size) > 1 && (
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 px-4 py-3 border-t border-gray-100 bg-gray-50/50">
            <div className="text-sm text-gray-500">
              Showing {(filter.pageNo - 1) * filter.size + 1} to{" "}
              {Math.min(filter.pageNo * filter.size, total)} of {total} entries
            </div>
            <ReactPaginate
              previousLabel={"Prev"}
              nextLabel={"Next"}
              breakLabel={"..."}
              breakClassName={"px-2 text-gray-400"}
              pageCount={Math.ceil(total / filter.size)}
              marginPagesDisplayed={1}
              pageRangeDisplayed={2}
              onPageChange={handlePageClick}
              containerClassName={"flex items-center gap-1"}
              pageClassName={"px-2"}
              pageLinkClassName={
                "px-3 py-1 text-sm text-gray-600 rounded-md hover:bg-[#715EFE]/10 hover:text-[#715EFE] transition-colors duration-200"
              }
              previousClassName={"px-2"}
              previousLinkClassName={
                "px-3 py-1 text-sm text-gray-600 rounded-md hover:bg-[#715EFE]/10 hover:text-[#715EFE] transition-colors duration-200"
              }
              nextClassName={"px-2"}
              nextLinkClassName={
                "px-3 py-1 text-sm text-gray-600 rounded-md hover:bg-[#715EFE]/10 hover:text-[#715EFE] transition-colors duration-200"
              }
              activeClassName={"bg-[#715EFE] text-white rounded-md"}
              activeLinkClassName={
                "bg-[#715EFE] text-white px-3 py-1 rounded-md"
              }
              disabledClassName={"opacity-50 cursor-not-allowed"}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default SessionManagementTable;
